import { render, staticRenderFns } from "./Loginstc.vue?vue&type=template&id=9453a91a&scoped=true"
import script from "./Loginstc.vue?vue&type=script&lang=js"
export * from "./Loginstc.vue?vue&type=script&lang=js"
import style0 from "./Loginstc.vue?vue&type=style&index=0&id=9453a91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9453a91a",
  null
  
)

export default component.exports